import axios from '../config/axios';
import { encryptSensitiveEntry } from '../utils/crypto/sensitiveEntryCrypto';

function buildEntryPayload(entry) {
  return {
    category: entry.category ?? '',
    title: entry.title ?? '',
    keywords: entry.keywords ?? [],
    detail: entry.detail ?? '',
    detailHtml: entry.detailHtml ?? entry.detail_html ?? '',
    entryTypeIds: entry.entryTypeIds ?? entry.entry_type_ids ?? [],
    entrySubtypeIds: entry.entrySubtypeIds ?? entry.entry_subtype_ids ?? [],
    isPublic: Boolean(entry.isPublic ?? entry.is_public),
    isSensitive: Boolean(entry.isSensitive ?? entry.is_sensitive),
  };
}

export async function saveEntry({
  entry,
  token,
  entryId = null,
  sensitiveKey = null,
}) {
  if (!entry) {
    throw new Error('Entry is required');
  }

  if (!token) {
    throw new Error('Auth token is required');
  }

  const config = { headers: { Authorization: `Bearer ${token}` } };

  const basePayload = buildEntryPayload(entry);

  let payload = { ...basePayload };

  if (payload.isSensitive) {
    if (payload.isPublic) {
      throw new Error('Entry cannot be both public and sensitive');
    }

    if (!sensitiveKey) {
      throw new Error('Sensitive key is required to save a sensitive entry');
    }

    const encrypted = await encryptSensitiveEntry({
      detail: payload.detail,
      detailHtml: payload.detailHtml,
      key: sensitiveKey,
    });

    payload = {
      ...payload,
      detail: encrypted.detail,
      detailHtml: encrypted.detailHtml,
      detailIv: encrypted.detailIv,
      detailAuthTag: encrypted.detailAuthTag,
      detailAlgo: encrypted.detailAlgo,
      detailKeyVersion: encrypted.detailKeyVersion,
      detailHtmlIv: encrypted.detailHtmlIv,
      detailHtmlAuthTag: encrypted.detailHtmlAuthTag,
      detailHtmlAlgo: encrypted.detailHtmlAlgo,
      detailHtmlKeyVersion: encrypted.detailHtmlKeyVersion,
    };
  } else {
    payload = {
      ...payload,
      detailIv: undefined,
      detailAuthTag: undefined,
      detailAlgo: undefined,
      detailKeyVersion: undefined,
      detailHtmlIv: undefined,
      detailHtmlAuthTag: undefined,
      detailHtmlAlgo: undefined,
      detailHtmlKeyVersion: undefined,
    };
  }

  if (entryId) {
    await axios.put(`/userdatad/${entryId}`, payload, config);
    return entryId;
  } else {
    const res = await axios.post('/userdatad', payload, config);
    return res.data.id;
  }
}
